import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import IconedCallout from 'components/Common/IconedCallout'
import PaneBody from '../Pane/PaneBody'

const Root = styled(Pane)`
  height: 100%;
`

interface Props extends React.ComponentProps<typeof Pane> {
  title: string;
  text: string;
  icon: React.ReactNode;
  size?: React.ComponentProps<typeof PaneBody>['size'];
}

function KeyMessageTile(props: Props) {
  const { title, text, icon, size, ...paneProps } = props

  return (<Root {...paneProps}>
    <PaneBody size={size}>
      <IconedCallout
        icon={icon}
        title={title}
        text={text}
      />
    </PaneBody>
  </Root>)
}

export default KeyMessageTile
